import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/ducks";
//components
import {
  ITableModel,
  noStatusBionexo,
  NotParticipateStatus,
  SupplierStatusType,
  StatusType,
} from "components/Table/interface";
import { VisibilityConditional } from "components/VisibilityConditional";
import { Button } from "components/Button";
import { Visibility } from "components/Visibility";
import QuoteItemIndicators from "./QuoteItemIndicators";
import ToggleButton from "pages/Quotes/components/generics/ToogleButton";
//interfaces
import { handlePendingMoneyErrorIcon, messageTooltip } from "pages/Quotes/MoneyRecordedQuotes/models";
import { IQuotes } from "models/Quote";
import { PortalOrder } from "models/portalModels/PortalOrder";
import { IQuoteDetail } from "models/QuoteDetail";
import { INotParticipateObservation } from "models/portalModels/ItemObservation";
//utils
import { dateExpiresInOneHour } from "utils/DateExpiresInOneHour";
import { generateRandomId } from "utils/GenerateRandomId";
import { format, getYear } from "date-fns";
//generics
import { Tooltip } from "react-tooltip";
//assets
import orangeCircleIcon from "img/orange-circle-icon.svg";
import IndicatorFilterIcon from "img/icon-filter.svg";
//services
import QuoteServices from "services/quote.service";
//style
import {
  Space,
  Tag,
  TooltipContainer,
  TooltipItemNotParticipate,
  TooltipPreOrderIcon,
  ButtonIndicatorFilter,
  CustomIcon,
  CompanyNameTooltip,
  CompanyNameContainer,
  CustomButton,
  CategoryCellContent,
} from "./styles";

type SaveQuotationViewedType = (
  dataQuote: IQuotes, 
  quotationViewed: boolean, 
  readQuote?: boolean, 
  isRead?: boolean
) => Promise<void>;

export const isReadStatus = (read?: boolean) =>
  read
    ? "quote-viewed not-participate-mouse-over"
    : "quote-notViewed not-participate-mouse-over";

export const isReadViewed = (read?: boolean) =>
  read ? "quote-viewed" : "quote-notViewed";

const reactTooltipId = generateRandomId("ReactTooltipPreOrderTag");
const quoteService = new QuoteServices();

export const getCustomStatusDescription = (data: IQuotes | IQuoteDetail, viewHeaderInformations: boolean = false) => {
  const statusDescription = 'statusDescription' in data
    ? data.statusDescription
    : data.status || data.supplierStatus || data.supplierStatusMessage;

  if (viewHeaderInformations) {
    switch (statusDescription) {
      case "Aberta":
        return "Disponível";
      case "Enviada":
        return "Respondida Portal";
      case "Fechada":
        return "Expirada";
      default:
        return statusDescription;
    }
  }

  switch (statusDescription) {
    case "Aberta":
      return "Aberta / Disponível";
    case "Enviada":
      return "Enviada / Respondida Portal";
    case "Fechada":
      return "Fechada / Expirada";
    default:
      return statusDescription;
  }
};

export const viveoStatus = (
  data: IQuotes,
  hasPendingMoneyErrorIcon: boolean,
  saveQuotationViewed: SaveQuotationViewedType
) => {
  const user = useSelector((stateUser: RootState) => stateUser.user);
  const bcgOnly = process.env.REACT_APP_BCG_ONLY === 'true';

  const tooltipWithoutUser = (
    <p className="text-styles text-center">
      {data.quotationNotParticipateStatusDescription}
    </p>
  );

  const tooltipWithUser = (
    <p className="text-styles text-center">
      {data.quotationNotParticipateStatusDescription}
      <br />
      <b className="color-blue-gray fs-2">
        {data.userWhoSavedNotParticipateStatus}
      </b>
    </p>
  );

  const statusDescription = (data.supplierStatusDescription === SupplierStatusType.DISREGARDED && !(bcgOnly || user?.isBCGUser))
    ? getCustomStatusDescription(data)
    : data.supplierStatusDescription;

  if (statusDescription === SupplierStatusType.PENDING_MONEY ||
    (statusDescription === SupplierStatusType.ANSWERED_PORTAL && data.hasPendingBudget)) {
    return (
      <div style={{ display: "flex" }}>
        {handlePendingMoneyErrorIcon(hasPendingMoneyErrorIcon)}
        <Button
          className={isReadStatus(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
          tooltip={messageTooltip(data)}
        >
          {statusDescription}
        </Button>
      </div>
    );
  } else if (data.quotationNotParticipateStatusDescription) {
    return (
      <TooltipContainer>
        <TooltipItemNotParticipate isRead={data.isRead}>
          {data.userWhoSavedNotParticipateStatus
            ? tooltipWithUser
            : tooltipWithoutUser}
        </TooltipItemNotParticipate>
        <Button
          html
          className={isReadStatus(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {statusDescription}
        </Button>
      </TooltipContainer>
    );
  } else if (
    statusDescription === SupplierStatusType.ANSWERED_BIONEXO
  ) {
    return (
      <Button
        className={isReadStatus(data.isRead)}
        onClick={() => saveQuotationViewed(data, true)}
        width="auto"
        tooltip={"Respondida diretamente na Bionexo"}
      >
        {statusDescription}
      </Button>
    );
  }

  return (
    <Button
      className={isReadStatus(data.isRead)}
      onClick={() => saveQuotationViewed(data, true)}
      width="auto"
      tooltip={data.quotationNotParticipateStatusDescription}
    >
      {statusDescription}
    </Button>
  );
};

const renderAgreementText = (data: PortalOrder) => {

  if(data.origin === "BIONEXO") {
    switch (data.isAgreement) {
      case false:
        return "Não";
      case true:
        return "Sim";
      default:
        return "Não";
    }
}
  return "Não";
};

const getButtonClass = (isRead?: boolean): string =>
  isRead ? "quote-viewed text-left" : "quote-notViewed text-left";

const getButtonExpiresClass = (data: IQuotes): string => {
  const baseClass = data.isRead ? "quote-viewed" : "quote-notViewed";
  const expiresClass = dateExpiresInOneHour(data.expiresAt.toString()) ? "quote-almost-expired" : "";

  return `${baseClass} ${expiresClass}`.trim();
};

export const dashboardOrderModel = () => {
  const model: ITableModel[] = [
    {
      label: "",
      key: "blockedQuote",
      size: 64,
      noFilter: true,
    },
    {
      label: "Pedido",
      key: "code",
      size: 120,
      noFilter: true,
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          <Visibility visible={data?.isRecent}>
            <img src={orangeCircleIcon} className="orangeIcon" alt="" />
          </Visibility>
          {data.code}
        </Button>
      ),
    },
    {
      label: "Primeiro resgate",
      key: "createdAt",
      size: 140,
      type: "date",
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          {format(new Date(data.createdAt), "dd/MM/yyyy' às 'HH:mm")}
        </Button>
      ),
    },
    {
      label: "Último resgate",
      key: "lastCreatedAt",
      size: 140,
      type: "date",
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          <VisibilityConditional
            condition={getYear(new Date(data.lastCreatedAt)) < 2000}
            firstOption={() => "-"}
            secondOption={() => format(new Date(data.lastCreatedAt), "dd/MM/yyyy' às 'HH:mm")}
          />
        </Button>
      ),
    },
    {
      label: "C. Cliente",
      key: "customerCode",
      size: 90,
      noFilter: true,
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          {data.customerCode}
        </Button>
      ),
    },
    {
      label: "Razão Social",
      key: "socialReason",
      size: 415,
      noFilter: true,
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          {data.socialReason}
        </Button>
      ),
    },
    {
      label: "Origem",
      key: "origin",
      size: 85,
      noFilter: true,
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          {data.origin}
        </Button>
      ),
    },
    {
      label: "Categoria",
      key: "quoteCategoryDescription",
      size: 100,
      maxSize: 140,
      noFilter: true,
      Component: (data: PortalOrder) => (
        <Button
          width="auto"
          className={isReadStatus(data.isRead)}
          tooltip={data.quoteCategoryDescription}
          toolTipPlace="top"
        >
          <CategoryCellContent>{data.quoteCategoryDescription}</CategoryCellContent>
        </Button>
      ),
    },
    {
      label: "Status do pedido",
      key: "statusDescription",
      size: 125,
      noFilter: true,
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          {data.statusDescription}
        </Button>
      ),
    },
    {
      label: "Acordo",
      key: "isAgreement",
      size: 85,
      noFilter: true,
      Component: (data: PortalOrder) => (
        <Button width="auto" className={isReadStatus(data.isRead)}>
          {renderAgreementText(data)}
        </Button>
      ),
    },
  ];

  return model;
};

export const dashboardQuoteModel = (
  renderButton: Function,
  saveQuotationViewed: SaveQuotationViewedType,
  onReload: Function,
  openModal: () => void
) => {

  const saveFieldNotParticipateStatus = async (quote: IQuotes) => {
    const reasonNonParticipant = "Sem motivo selecionado";
    const typeNonParticipant = "NO_REASON_SELECTED";
    const notParticipateModel: INotParticipateObservation = {
      quotationId: quote.id,
      notParticipateType: typeNonParticipant,
      notParticipateMessage: reasonNonParticipant,
    };

    const isNonParticipantGrid =
      quote.supplierStatusDescription ===
      SupplierStatusType.DO_NOT_PARTICIPATE &&
      quote.quotationNotParticipateStatusDescription ===
      NotParticipateStatus.NO_REASON_SELECTED;

    if (isNonParticipantGrid) {
      await quoteService.rollbackFieldNotParticipateStatus(notParticipateModel);
      onReload();
      return;
    }

    await quoteService.saveFieldNotParticipateStatus(notParticipateModel);
    onReload();
  };

  const saveQuotationViewedHandler = (data: IQuotes) => {
    saveQuotationViewed(data, data.quotationViewed, true, !data.isRead);
  };

  const model: ITableModel[] = [
    {
      label: "",
      key: "blockedQuote",
      size: 60,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Visibility visible={!!data.viewList}>
          <Space />
          {renderButton(data)}
        </Visibility>
      ),
    },
    {
      label: "Cotação",
      key: "code",
      size: 100,
      noFilter: true,
      Component: (data: IQuotes) => (
        <>
          <Visibility visible={data.hasPreOrder}>
            <TooltipContainer>
              <TooltipPreOrderIcon>
                Possui pedido(s) resgatado(s)
              </TooltipPreOrderIcon>
              <Tag>PR</Tag>
            </TooltipContainer>
            <Tooltip id={reactTooltipId} variant="light" />
          </Visibility>
          <Button
            className={isReadViewed(data.isRead)}
            onClick={() => saveQuotationViewed(data, true)}
            width="auto"
          >
            {data.code}
          </Button>
        </>
      ),
    },
    {
      label: "Criação",
      key: "createdAt",
      size: 90,
      type: "date",
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          <>
            {format(new Date(data.createdAt), "dd/MM/yyyy")}
            <br />
            {format(new Date(data.createdAt), "'às 'HH:mm")}
          </>
        </Button>
      ),
    },
    {
      label: "C. Cliente",
      key: "company.crmCustomerCode",
      size: 80,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {data.company?.crmCustomerCode}
        </Button>
      ),
    },
    {
      label: "Razão Social",
      key: "buyerName",
      size: 280,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={getButtonClass(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {data.buyer?.name}
        </Button>
      ),
    },
    {
      label: "Categoria",
      key: "categoryMafra",
      size: 115,
      maxSize: 210,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
          tooltip={data.categoryMafra}
          toolTipPlace="top"
        >
          <CategoryCellContent>{data.categoryMafra}</CategoryCellContent>
        </Button>
      ),
    },
    {
      label: "Qtd",
      key: "itemsCount",
      size: 20,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {data.itemsCount}
        </Button>
      ),
    },
    {
      label: "Status da cotação",
      key: "statusDescription",
      tooltipText: "Status Origem/Status Viveo",
      size: 200,
      noFilter: true,
      isCenter: true,
      Component: (data: IQuotes) => (
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {
            data.statusDescription === StatusType.PROCESSING 
            ? data.statusDescription
            : !noStatusBionexo.includes(data.supplierStatusDescription) 
              ? (
                  <>
                    {data.statusDescription} / {viveoStatus(data, false, saveQuotationViewed)}
                  </>
                )
              : viveoStatus(data, false, saveQuotationViewed)
          }
        </Button>
      ),
    },
    {
      label: "Expira em",
      key: "expiresAt",      
      type: "date/hour",
      size: 115,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={getButtonExpiresClass(data)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          <>
            {format(new Date(data.expiresAt), "dd/MM/yyyy")}
            <br />
            {format(new Date(data.expiresAt), "'às 'HH:mm")}
          </>
        </Button>
      ),
    },
    {
      label: "Origem",
      key: "origin",      
      isCenter: true,
      size: 90,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {data.origin}
        </Button>
      ),
    },
    /*{
      label: "Não partic.",
      key: "nonParticipant",
      size: 90,
      noFilter: true,
      isCenter: true,
      Component: (data: IQuotes) => (
        <ToggleButton
          onClick={() => saveFieldNotParticipateStatus(data)}
          value={
            data.supplierStatusDescription ===
            SupplierStatusType.DO_NOT_PARTICIPATE
          }
          isBlocked={
            data.supplierStatusDescription !==
            SupplierStatusType.VALIDATE_PORTAL &&
            data.supplierStatusDescription !== SupplierStatusType.EXPIRED &&
            data.quotationNotParticipateStatusDescription !==
            NotParticipateStatus.NO_REASON_SELECTED
          }
        />
      ),
    },*/
    {
      label: "Indicadores",
      iconFilter: (
        <ButtonIndicatorFilter onClick={openModal} id="button-indicator-filter">
          <CustomIcon src={IndicatorFilterIcon} alt="Icon" />
        </ButtonIndicatorFilter>
      ),
      alignRight: true,
      key: "indicators",
      size: 140,
      noFilter: true,
      Component: (data: IQuotes) => (
        <QuoteItemIndicators data={data} saveQuotationViewed={() => saveQuotationViewedHandler(data)} />
      ),
    },
  ];

  return model;
};

export const newDashboardQuoteModel = (
  renderButton: Function, 
  saveQuotationViewed: SaveQuotationViewedType,
  openModal: () => void,
  onReload: Function
) => {
  const saveQuotationViewedHandler = (data: IQuotes) => {
    saveQuotationViewed(data, data.quotationViewed, true, !data.isRead);
  };

  const saveFieldNotParticipateStatus = async (quote: IQuotes) => {
    const reasonNonParticipant = "Sem motivo selecionado";
    const typeNonParticipant = "NO_REASON_SELECTED";
    const notParticipateModel: INotParticipateObservation = {
      quotationId: quote.id,
      notParticipateType: typeNonParticipant,
      notParticipateMessage: reasonNonParticipant,
    };


    const isNonParticipantGrid = quote.supplierStatusDescription === SupplierStatusType.DO_NOT_PARTICIPATE
      && quote.quotationNotParticipateStatusDescription === NotParticipateStatus.NO_REASON_SELECTED;

    if (isNonParticipantGrid) {
      await quoteService.rollbackFieldNotParticipateStatus(notParticipateModel);
      onReload();
      return;
    }

    await quoteService.saveFieldNotParticipateStatus(notParticipateModel);
    onReload();
  };

  const isViewedClass = (data: IQuotes): string => data.isRead ? "quote-viewed" : "quote-notViewed";
  const isAlmostExpiredClass = (data: IQuotes): string => dateExpiresInOneHour(data.expiresAt.toString()) ? "quote-almost-expired" : "";
  const generateDisregardedMessage = (data: IQuotes): string => data.priorityBCG?.priorityEmoji === 0 &&
    data.supplierStatusDescription === SupplierStatusType.DISREGARDED ? "A cotação foi desconsiderada por condições comerciais" : "";

  const model: ITableModel[] = [
    {
      label: "",
      key: "blockedQuote",
      size: 75,
      noFilter: true,
      Component: (data: IQuotes) =>
        <Visibility visible={!!data.viewList}>
          <Space />
          {renderButton(data)}
        </Visibility>
    },
    {
      label: "Cotação",
      key: "code",
      size: 100,
      noFilter: true,
      maxSize: 100,
      isButton: true,
      Component: (data: IQuotes) =>
        <>
          <Visibility visible={data.hasPreOrder}>
            <Tag
              data-for={reactTooltipId}
              data-tip={"Possui pedido(s) resgatado(s)"}
              data-place={"top"}
            >
              PR
            </Tag>
            <Tooltip id={reactTooltipId} variant="light" />
          </Visibility>
          <CustomButton
            className={isReadViewed(data.isRead)}
            onClick={() => saveQuotationViewed(data, true)}
            tooltip={generateDisregardedMessage(data)}
            width="auto"
          >
            {data.code}
          </CustomButton>
        </>
    },
    {
      label: "Criação",
      key: "createdAt",
      size: 95,
      type: "date",
      noFilter: true,
      maxSize: 95,
      isButton: true,
      Component: (data: IQuotes) =>
        <CustomButton
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          <>
            {format(new Date(data.createdAt), "dd/MM/yyyy")}
            <br />
            {format(new Date(data.createdAt), "'às 'HH:mm")}
          </>
        </CustomButton>
    },
    {
      label: "C. Cliente",
      key: "company.crmCustomerCode",
      size: 90,
      noFilter: true,
      maxSize: 90,
      isButton: true,
      Component: (data: IQuotes) =>
        <CustomButton
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {data.company?.crmCustomerCode}
        </CustomButton>
    },
    {
      label: "Razão Social",
      key: "buyerName",
      size: 185,
      noFilter: true,
      isButton: true,
      Component: (data: IQuotes) =>
        <CustomButton onClick={() => saveQuotationViewed(data, true)} width="auto">
          <CompanyNameContainer>
            <CompanyNameTooltip
              className={data.isRead ? "quote-viewed text-left" : 'quote-notViewed text-left'}
              showTip
              toolTipPlace="top"
              showTipContent={data.buyer?.name}
            >
              {data.buyer?.name}
            </CompanyNameTooltip>
          </CompanyNameContainer>
        </CustomButton>
    },
    {
      label: "Categoria",
      key: "categoryMafra",
      size: 110,
      maxSize: 210,
      noFilter: true,
      isButton: true,
      Component: (data: IQuotes) =>
        <CustomButton
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
          tooltip={data.categoryMafra}
          toolTipPlace="top"
        >
          <CategoryCellContent>{data.categoryMafra}</CategoryCellContent>
        </CustomButton>
    },
    {
      label: "Qtd",
      key: "itemsCount",
      size: 35,
      noFilter: true,
      isButton: true,
      Component: (data: IQuotes) =>
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {data.itemsCount}
        </Button>
    },
    {
      label: "Status da cotação",
      key: "statusDescription",
      size: 221,
      noFilter: true,
      isButton: true,
      tooltipText: "Status Origem/Status Viveo",
      Component: (data: IQuotes) =>
        <CustomButton
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          tooltip={generateDisregardedMessage(data)}
          width="auto"
        >
          {
            
            data.statusDescription === StatusType.PROCESSING 
            ? data.statusDescription
            : !noStatusBionexo.includes(data.supplierStatusDescription) 
              ? (
                  <>
                    {data.statusDescription} / {viveoStatus(data, false, saveQuotationViewed)}
                  </>
                )
              : viveoStatus(data, false, saveQuotationViewed)
          }
        </CustomButton>
    },
    {
      label: "Expira em",
      key: "expiresAt",
      type: "date/hour",
      size: 85,
      noFilter: true,
      isButton: true,
      Component: (data: IQuotes) =>
        <Button
          className={`${isViewedClass(data)} ${isAlmostExpiredClass(data)}`}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          <>
            {format(new Date(data.expiresAt), "dd/MM/yyyy")}
            <br />
            {format(new Date(data.expiresAt), "'às 'HH:mm")}
          </>
        </Button>
    },
    {
      label: "Origem",
      key: "origin",      
      isCenter: true,
      size: 90,
      noFilter: true,
      Component: (data: IQuotes) => (
        <Button
          className={isReadViewed(data.isRead)}
          onClick={() => saveQuotationViewed(data, true)}
          width="auto"
        >
          {data.origin}
        </Button>
      ),
    },
    /*{
      label: "Não partic.",
      key: "nonParticipant",
      size: 90,
      noFilter: true,
      isButton: true,
      isCenter: true,
      Component: (data: IQuotes) => (
        <ToggleButton
          onClick={() => saveFieldNotParticipateStatus(data)}
          value={data.supplierStatusDescription === SupplierStatusType.DO_NOT_PARTICIPATE}
          isBlocked={data.supplierStatusDescription !== SupplierStatusType.VALIDATE_PORTAL
            && data.supplierStatusDescription !== SupplierStatusType.EXPIRED
            && data.quotationNotParticipateStatusDescription !== NotParticipateStatus.NO_REASON_SELECTED}
        />
      ),
    },*/
    {
      label: "Indicadores",
      iconFilter: (
        <ButtonIndicatorFilter onClick={openModal} id="button-indicator-filter">
          <CustomIcon src={IndicatorFilterIcon} alt="Icon" />
        </ButtonIndicatorFilter>
      ),
      alignRight: true,
      key: "indicators",
      size: 140,
      noFilter: true,
      Component: (data: IQuotes) => (
        <QuoteItemIndicators data={data} saveQuotationViewed={() => saveQuotationViewedHandler(data)} />
      ),
    }
  ];

  return model;
};